import React, { useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { ROLE_ADMIN } from '../../constants/roles';
import { PURCHASE_PROCESS_TYPES } from '../../constants/carOrigin';
import isUserHaveRole from '../../utils/isUserHaveRole';
import getItems from '../../api/cars/getItems';

// components
import Header from '../../components/Header/Header';
import Navbar from '../../components/Navbar/Navbar';
import Breadcrumbs from '../../components/Breadcrumbs';

// icons
import leads from '../../brand/generated/sidebar/cars.svg';

const CarNavigation = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const [showBuTab, setShowBuTab] = useState(false);

  useEffect(() => {
    if (!id) return;
    getItems({ id })
      .then((res) => {
        const car = res?.data?.cars?.[0];
        const origin = car?.originCarId;
        const allowed = PURCHASE_PROCESS_TYPES;
        setShowBuTab(allowed.includes(origin));
      })
      .catch(() => {
        setShowBuTab(false);
      });
  }, [id]);

  const items = useMemo(() => {
    const baseItems = [
      { text: 'ÐÑÐ½Ð¾Ð²Ð½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ', navigate: id ? `/cars/car/${id}/main-data` : '/cars/create' },
      { text: 'ÐÐ¾Ð¿ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ', navigate: id ? `/cars/car/${id}/equipments` : '/cars/create' },
      { text: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ', navigate: id ? `/cars/car/${id}/documents` : '/cars/documents' },
    ];

    if (id && showBuTab) {
      baseItems.push({ text: 'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ', navigate: `/cars/car/${id}/bu-info` });
    }

    if (isUserHaveRole(ROLE_ADMIN)) {
      baseItems.push({ text: 'Ð¡Ð´ÐµÐ»ÐºÐ¸', navigate: id ? `/cars/car/${id}/deals` : '/cars/deals' });
    }

    return baseItems;
  }, [id, showBuTab]);

  return (
    <>
      <Header title={id ? `ID ${id}` : 'ÐÐ¾Ð²ÑÐ¹ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ'} icon={leads} />
      <Breadcrumbs
        navigate={'/cars'}
        link={'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸'}
        currentPage={id ? `ID ${id}` : 'ÐÐ¾Ð²ÑÐ¹ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ'}
      />
      {!pathname.endsWith('/create') && <Navbar items={items} />}
      <Outlet />
    </>
  );
};

export default CarNavigation;
